// this class knows current state for module (current groupBy)
// this class manages fields available for grouping
// this class DOES NOT group !!!!

import GenericListModule from "../generic-list-module";
import {SortDirection} from "../../../data-structures/sort";
import {GlistGroupByConfig, GlistGroupBySettings} from "../@types";

const debug = false
// const debug = "GroupByManager"

export default class GroupByManager {

    public module       : GenericListModule
    private _value      : fieldId | null
    private _groupSortingDirection  : SortDirection
    private groupsCollapsed : {[key:string] : fieldId[]}
    public isEnabled        : boolean

    public options         : any[]

    constructor(module:GenericListModule, groupByConfig:GlistGroupByConfig) {
        this.module = module;
        this._value =                   _.get(groupByConfig, 'value.fieldId', null);

        debug && console.log(debug, 'constructor', this._value, this._value ? this.module.fields.get(this._value) : null, this.module.fields)

        // ensure group by filed exists otherwise set to null
        if (this._value && !this.module.fields.get(this._value)) this._value = null

        this._groupSortingDirection =   _.get(groupByConfig, 'value.groupSortDirection', SortDirection.ASC);
        // @ts-ignore
        this.groupsCollapsed =          _.get(groupByConfig, 'groupsCollapsed', {});

        this.options =                  _.get(groupByConfig, 'options', [{
            id      : null,
            label   : "None",
            info    : "No grouping",
            noSort  : true,
        }]);

        // true if group by enabled
        this.isEnabled = !!this._value;
    }

    set(fieldId: fieldId | null, direction: SortDirection) {
        this._value                 = fieldId
        this.isEnabled              = !!this._value

        this._groupSortingDirection = direction

        this._updateModule()
    }

    set value(fieldId) {
        this._value = fieldId;
        this.isEnabled = !!this._value;

        debug && console.log(debug, 'set value', this._value)

        this._updateModule();
    }

    get value():ID|null {
        return this._value;
    }

    set direction(direction) {
        this._groupSortingDirection = direction;
        this._updateModule();
    }

    get direction() {
        return this._groupSortingDirection;
    }

    toggleGroup(id:string) {
        if (!this._value) return false

        // prepare array if not created yet
        if (!this.groupsCollapsed[this._value]) this.groupsCollapsed[this._value] = []

        // toggle collapsed group id
        this.groupsCollapsed[this._value] = gd.utils.toggleArrayValue(this.groupsCollapsed[this._value], id)

        // remove if no items
        if (this.groupsCollapsed[this._value].length === 0)
            delete this.groupsCollapsed[this._value]

        debug && console.log(debug, 'toggleGroup', id, this.groupsCollapsed[this._value])

        this.module.onToggleGroup()
    }

    collapseAll() {
        if (!this._value) return false

        this.groupsCollapsed[this._value] = _.map(this.module.data.get(), group=>group.groupByValue)

        debug && console.log(debug, 'collapseAll', this.groupsCollapsed[this._value], this.module.data.get())

        this.module.onToggleGroup()
        this.module.reRender()
    }

    expandAll() {

        if (!this._value) return false

        delete this.groupsCollapsed[this._value]

        debug && console.log(debug, 'expandAll', this.groupsCollapsed[this._value])

        this.module.onToggleGroup()
        this.module.reRender()
    }

    isCollapsed(id:string) {

        if (!this._value) return false

        return this.groupsCollapsed[this._value] && this.groupsCollapsed[this._value].includes(id);
    }

    hasAnyCollapsed() {

        debug && console.log(debug, "hasAnyCollapsed()")

        if (!this._value) return false

        debug && console.log(debug, 'hasAnyCollapsed', this._value, this.groupsCollapsed[this._value])

        return this.groupsCollapsed[this._value] && !_.isEmpty(this.groupsCollapsed[this._value])
    }

    hasAnyExpanded() {

        debug && console.log(debug, "hasAnyExpanded()")

        if (!this._value) return false

        debug && console.log(debug, 'hasAnyExpanded', this._value, this.groupsCollapsed[this._value])

        return !this.groupsCollapsed[this._value] || this.groupsCollapsed[this._value].length !== this.module.data.get().length
    }

    _updateModule() {
        this.module.onGroupByChanged();
        this.module.data.process();
        this.module.reRender();
    }

    toJSON():GlistGroupBySettings {
        return {
            fieldId: this.value ? this.value : undefined,
            groupSortDirection: this._groupSortingDirection
        }
    }
}
